import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import type { MdoInterimReportAdvice, MdoReportAdvice } from '@common/customControls/bariatrics';
import { ProcessActivityStatus } from '@common/enums';

type BariPreNotIncludedAlertProps = Readonly<{
    advice: MdoInterimReportAdvice | MdoReportAdvice | null;
    processActivityStatus: ProcessActivityStatus;
}>;

export function BariPreNotIncludedAlert({
    advice,
    processActivityStatus,
}: BariPreNotIncludedAlertProps): JSX.Element | null {
    if (processActivityStatus !== ProcessActivityStatus.complete || advice !== 'Patiënt niet includeren') {
        return null;
    }

    return (
        <Alert appearance="info">
            De patiënt wordt niet geïncludeerd in het zorgpad. Er is een bericht naar de huisarts gestuurd.
        </Alert>
    );
}
